// extracted by mini-css-extract-plugin
export var divider = "_37-0";
export var dividerText = "_37-2";
export var dividerVertical = "_37-1";